import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OfferService } from 'src/app/services/offer.service';
import { OfferDetailModel } from 'src/app/models/wardrobe.model';
import { HamburgerMenuComponent } from 'src/app/components/hamburger-menu/hamburger-menu.component';

@Component({
  selector: 'shc-swops',
  templateUrl: './swops.page.html',
  styleUrls: ['./swops.page.scss'],
})
export class SwopsPage implements OnInit {
  direction: 'received' | 'sent' = 'received';
  offers: OfferDetailModel[] = [];
  loading = false;

  constructor(
    private offerService: OfferService,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
    this.loadOffers();
  }

  ionViewWillEnter() {
    this.loadOffers();
  }

  segmentChanged(event: any) {
    this.direction = event.detail.value;
    this.loadOffers();
  }

  loadOffers() {
    this.loading = true;
    this.offerService.offersList({ direction: this.direction, per_page: 50 }).subscribe({
      next: (res) => {
        this.offers = res.data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  async openMenu() {
    const modal = await this.modalCtrl.create({
      component: HamburgerMenuComponent,
      cssClass: 'hamBurgermenu',
      canDismiss: true,
      id: 'hamBurgermenu',
    });
    modal.onDidDismiss().then(() => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }
}
